import {
  parseSavedFiltersPreference,
  parseSavedFiltersPreferenceWrite,
  SAVED_FILTERS_PREFERENCE_KEY,
} from '../models/reportPreferences.wire'

import { appHttp, decodeDto, unwrap } from '@/shared/http'

/** Backend-compatible boundary for the legacy `save_filters` workspace preference. */
export class ReportPreferencesApi {
  constructor(private readonly app: Pick<typeof appHttp, 'get' | 'post'> = appHttp) {}

  private config(signal?: AbortSignal) {
    return {
      ...(signal ? { signal } : {}),
      suppressGlobalErrorHandler: true,
      meta: { suppressGlobalErrorHandler: true },
    }
  }

  async fetchSavedFilters(
    accountId: number,
    workspaceId: number | string,
    signal?: AbortSignal,
  ): Promise<unknown[]> {
    const response = await this.app.get<unknown>(
      `/accounts/${accountId}/workspace/preferences/${workspaceId}/get/?key=${SAVED_FILTERS_PREFERENCE_KEY}`,
      this.config(signal),
    )
    return decodeDto(unwrap(response), parseSavedFiltersPreference)
  }

  async replaceSavedFilters(
    accountId: number,
    workspaceId: number | string,
    value: readonly unknown[],
    signal?: AbortSignal,
  ): Promise<void> {
    const body = unwrap(
      await this.app.post<unknown>(
        `/accounts/${accountId}/workspace/preferences/${workspaceId}/create/?upsert=true`,
        { key: SAVED_FILTERS_PREFERENCE_KEY, value },
        this.config(signal),
      ),
    )
    decodeDto(body, parseSavedFiltersPreferenceWrite)
  }
}

export const reportPreferencesApi = new ReportPreferencesApi()
